export const es = {
  dataIterator: {
    rowsPerPageText: 'Registros por página',
    rowsPerPageAll: 'Todos',
    pageText: '{0}-{1} de {2}',
    noResultsText: 'No se encontraron coincidencias',
    nextPage: 'Página siguiente',
    prevPage: 'Página anterior',
  },
  dataTable: {
    rowsPerPageText: 'Registros por página:',
  },
  login: {
    loginAccess: 'ACCEDE A TUS SERVICIOS',
    username: 'Correo electrónico',
    password: 'Contraseña',
    forgotPassword: '¿Olvidaste tu contraseña?',
    submit: 'Entrar',
    errors: {
      attemptError:
        'Has intentado demasiadas veces. \n Inténtalo de nuevo más tarde',
      eUsernameInvalid: 'El correo no es válido',
      eUsernameRequired: 'Usuario requerido',
      ePasswordRequired: 'La contraseña es requerida',
      eUserPass: 'Usuario y/o contraseña inválidos',
    },
  },
  recovery: {
    notFound: 'PÁGINA NO DISPONIBLE O CADUCADA',
    title: 'SOLICITUD DE RECUPERACIÓN DE CONTRASEÑA',
    emailInput: 'Introduce tu correo electrónico',
    sendedRequest:
      'Se ha enviado tu solicitud. Verifica tu correo electrónico para continuar.',
    changePassword: 'REGISTRO DE NUEVA CONTRASEÑA',
    newPassword: 'Introduce tu nueva contraseña',
    passwordUpdated:
      'Tu contraseña ha sido modificada exitosamente. Inicia sesión con tus nuevas credenciales.',
    login: 'Iniciar sesión',
    form: {
      email: 'Correo electrónico',
      password: 'Contraseña',
      cPassword: 'Confirmar contraseña',
    },
    errors: {
      title: 'Error',
      main: 'OCURRIÓ UN ERROR, INTÉNTALO DE NUEVO MÁS TARDE',
      eEmailInvalid:
        'No se encontró ningún registro con el correo ingresado, inténtalo nuevamente.',
      eEmailRequired: 'El correo es requerido',
      ePasswordRequired: 'La contraseña es requerida',
      eConfirmPasswordRequired: 'Confirmación de la contraseña es requerida',
      ePasswordsMatch: 'Las contraseñas no coinciden',
    },
    submit: 'ENVIAR',
  },
  qr: {
    title: 'GENERADOR DE QR',
  },
  modals: {
    ok: 'Aceptar',
    cancel: 'Cancelar',
    save: 'Guardar',
  },
  panel: {
    loading: 'Cargando',
    home: 'Panel de Administración',
    configuration: 'Configuración',
    levels: 'Niveles',
    extraLevels: 'Extracurriculares',
    employees: 'Colaboradores',
    students: 'Alumnos',
    parents: 'Tutores',
    devices: 'Dispositivos',
    reports: 'Reportes',
    rounds: 'Rondas',
    comunity: 'Comunidad',
    statistics: 'Estadísticas',
    visor: 'Salidas',
    visor2: 'Salidas (BETA)',
    changingBranch: 'Cambiando de instituto',
    unsavedChangesTitle: 'Cambios sin guardar',
    unsavedChangesDescription:
      'Tienes cambios sin guardar.<br/> ¿Deseas guardar los cambios?',
    consultCollaboratorQR: 'Consultar mi QR',
    activityCentre: 'Centro de actividades',
    logOut: 'Cerrar sesión',
    help: 'Centro de Ayuda',
    helpC:
      'Herramienta web donde compartimos material de apoyo acerca de Skolable',
    //Descriptions
    configDesc: 'Administra la configuración',
    levelsDesc: 'Añade y administra los diferentes niveles, grados y grupos',
    extraLevelsDesc:
      'Añade y administra los diferentes registros a niveles, grados y grupos extracurriculares de los alumnos',
    empDesc: 'Añade y administra a todos los colaboradores',
    stdDesc: 'Añade y administra todos los alumnos',
    parDesc: 'Añade y administra todos los padres de familia',
    devDesc: 'Añade y administra todos los dispositivos',
    repoDesc: 'Visualiza y descarga los diferentes reportes diarios',
    rndDesc: 'Visualiza, administra y gestiona las rondas de los tutores',
    comunDesc: 'Crea y administra eventos, avisos, reportes y permisos',
    statDesc:
      'Visualiza las estadísticas del proceso de entrega de los alumnos',
    visorDesc: 'Visualiza en tiempo real las transacciones de los alumnos',
    visor2Desc: 'Visualiza en tiempo real las transacciones de los alumnos',
    pagos: 'Pagos',
    pagosDesc: 'Administra y emite pagos de diferentes conceptos',
    encuestas: 'Encuestas',
    encuestasDesc: 'Añade y administra todas las encuestas',
    helpcenter: 'Centro de Ayuda',

    subgrupos: 'Subgrupos',
    subgruposDesc:
      'Crea y administra los subgrupos y horarios para el regreso a clases por bloques',
    citas: 'Citas',
    citasDesc: 'Añade y administra todas las citas',
    update: 'Actualizaciones',
    updateDesc: 'Actualizaciones skolable',
    workshop: 'Talleres',
    workshopDesc: 'Añade y administra todos los talleres',
    classroom: 'Salones',
    classroomDesc: 'Añade y administra todos los salones',
    holiday: 'Días de asueto',
    holidayDesc: 'Añade y administra todos los días de asueto',
    schedule: 'Horarios de colaboradores',
    scheduleDes:
      'Gestiona horarios para tus colaboradores y visualiza los reportes de asistencia',
    superAdmin: 'Listado de colegios',
    superAdminDes:
      'Gestiona horarios para tus colaboradores y visualiza los reportes de asistencia',
    authorizations: 'Pases de salida',
    authorizationsDesc:
      'Visualiza todos los pases de salida de los alumnos que puede salir solos del colegio.',
    schoolTransportation: 'Transporte Escolar',
    schoolTransportationDescription:
      'Administra las rutas, choferes y alumnos del transporte escolar.',
  },
  SAPanel: {
    colleges: 'Colegios',
    collegesDesc: 'Administra tus colegios y licencias',
    collaborators: 'Colaboradores',
    collaboratorsDesc: 'Administra tus colaboradores',
  },
  SAHome: {
    title: 'Consola de Administración',
  },
  home: {
    unAuthorized: 'No autorizado',
    inDevelopment: 'En desarrollo',
    title: 'Panel de Administración',
  },
  activityCentre: {
    title: 'Centro de actividades',
    alerts: 'Alertas',
    initialConfiguration: 'Configuración inicial',
    doors: 'Puertas',
    dDesc1: 'Añadir al menos una puerta',
    levels: 'Niveles',
    lDesc1: 'Añadir al menos un Nivel',
    lDesc2: 'Ligar al menos una puerta a un nivel',
    lDesc3: 'Añadir al menos un grado y grupo a un nivel',
    employee: 'Colaboradores',
    eDesc1: 'Añadir al menos un colaborador',
    students: 'Alumnos',
    sDesc1: 'Añadir al menos un alumno',
    sDesc2: 'Ligar al menos un alumno a un tutor',
    parents: 'Tutores',
    pDesc1: 'Añadir al menos un tutor',
    pDesc2: 'Añadir al menos un código QR de familiar',
    pDesc3: 'Ligar al menos un tutor con un alumno',
    devices: 'Dispositivos',
    devDesc1: 'Añadir al menos un dispositivo Ipad y un dispositivo Único',
    initConfigMessage: 'Es necesario realizar las configuraciones iniciales',
    tutorsUnlink: 'Existen %d tutores sin alumnos',
    studentsUnlink: 'Existen %d estudiantes sin tutores',
  },
  visor: {
    search: 'Buscar',
    check_out: 'Salidas',
    start_dismissal: 'Iniciar salidas',
    edit_groups: 'Editar grupos',
    qr_assets_of_the_day: 'Qr activos del día',
    notification_interval: 'Intervalo de las notificaciones',
    notification_sound: 'Sonido de notificación',
    start_dismissal: 'Iniciar salidas',
    groups: 'Grupos',
    more_groups: 'grupos mas',
    total_students: 'Total Alumnos',
    requested: 'Solicitados',
    on_the_way: 'En camino',
    delivered: 'Entegados',
    updating_groups: 'Actualizando grupos',
    starting_dismissal: 'Iniciando salidas',
    dismissal_has_begun: 'Salidas iniciadas',
    dismissal_time_is_ending: 'Cerrando salidas',
    dismissal_time_has_ended: 'Salidas cerradas',
    something_went_wrong: 'Ups! ocurrió un error',
    updated_groups: 'Grupos actualizados',
  },
  generic: {
    qr_suspend: {
      suspend_qr_title_one: 'Suspender QR',
      suspend_qr_description_one:
        'Al suspender el QR de este usuario permanecerá inválido y no podrá utilizarse para el ingreso al colegio hasta que se active nuevamente.',
      suspend_qr_title_many: 'Suspender QR',
      suspend_qr_description_many:
        'Al suspender el QR de este usuario permanecerá inválido y no podrá utilizarse para el ingreso al colegio hasta que se active nuevamente.',
      reason:
        'Este motivo se mostrará cuando el usuario intente ingresar y tenga suspendido su QR',
    },
    modal_qr: {
      page_breaks_groups: "Descargar QR's sin salto de página entre grupos",
    },
    accept: 'Aceptar',
    cancel: 'Cancelar',
    save: 'Guardar',
    download: 'Descargar',
    alert: 'Alerta',
    close: 'Cerrar',
    more_options: 'Más opciones',
    options: 'Opciones',
    search: 'Buscar',
    successful_operation: 'Operación exitosa',
  },
  students: {
    students: 'Alumnos',
    search: 'Buscar',
    delete_student: 'Eliminar alumno',
    delete_students: 'Eliminar alumnos',
    options: 'Opciones',
    create_student: 'Crear alumno',
    photo: 'Foto',
    first_name: 'Nombre',
    last_name: 'Apellidos',
    level: 'Nivel',
    group: 'Grupo',
    tutors: 'Tutores',
    gender: 'Sexo',
    male: 'Masculino',
    female: 'Femenino',
    qr_status: 'Estatus QR',
    qr_code: 'QR',
    student_id: 'Matrícula',
    download_students: 'Descargar alumnos',
    download_tutors_and_students: 'Descargar tutores y alumnos',
    import_students_and_tutors: 'Importar alumnos y tutores',
    records_per_page: 'Registros por página',
    edit_student: 'Editar alumno',
    suspend_qr: 'Suspender QR',
    download_qr_s: 'Descarga de QRs',

    modal_student: {
      'name_(s)': 'Nombre (s)',
      last_name: 'Apellidos',
      level: 'Nivel',
      grade_and_group: 'Grado y grupo',
      student_id: 'Matrícula',
      male: 'Masculino',
      female: 'Femenino',
      cancel: 'CANCELAR',
      save: 'GUARDAR',
    },

    modal_qr: {
      indefinite: 'Indefinido ',
      reason_to_suspend_the_qr:
        'Ingresa el motivo por el que deseas suspender el QR',
      start_date: 'Fecha inicial ',
      end_date: 'Fecha de término',
      cancel: 'CANCELAR',
      suspend: 'SUSPENDER',
    },

    modal_download_qr: {
      qr_download: 'Descarga de QR',
      download_format: 'Elije el formato de descarga',
      qr_code_size: 'Tamaño de QR',
      qr_code_size_2: 'por página en tamaño carta.',
      small: 'Pequeño',
      large: 'Grande',
      page_breaks_groups: "Descargar QR's sin salto de página entre grupos",
      cancel: 'Cancelar',
      file_name:
        'Selecciona los datos con los que se guardará el nombre de tu archivo',
      download_pdf: 'Descargar pdf',
      download_png: 'Descargar png',

      student_id: 'Matrícula',
      first_name: 'Nombre',
      last_name: 'Apellido',
      all_of_the_above: 'Todos los anteriores',
      role: 'Rol',
    },

    table_parents: {
      save: 'Guardar',
      delete: 'Eliminar',
      photo: 'Foto',
      first_name: 'Nombre',
      last_name: 'Apellidos',
      e_mail: 'Correo',
      create_tutor: 'Crear un tutor',
      linking_a_tutor: 'Ligar un tutor',
    },

    tutor_modal: {
      create_tutor: 'Crear tutor',
      edit_tutor: 'Editar tutor',
    },

    modal_link_tutor: {
      add_tutor_to_student: 'Agregar tutor a alumno',
      name_of_the_parent_or_tutor: 'Escribe el nombre del padre o tutor',
      tutor_s_name: 'Nombre del tutor',
      select_one_or_more_tutors: 'Selecciona uno o varios tutores',
      cancel: 'CANCELAR',
      save: 'GUARDAR',
    },

    table_exta: {
      level: 'Nivel',
      activity_grade: 'Actividad/Grado',
      group: 'Grupo',
    },

    massive_upload: {
      steps: {
        upload_your_file: 'Sube tu archivo',
        content_verification: 'Verificación de contenido',
        detail: 'Detalle',
        validate_data: 'Validar datos',
        finished: 'Terminado',
      },

      step_1: {
        import_excel_file:
          'Importa tu archivo Excel de tus alumnos como se muestra en el ejemplo.',
        download: 'Descargar',
        drag_file_1: 'Arrastra tu archivo Excel aquí',
        drag_file_2: ' O ',
        drag_file_3: 'selecciona ',
        drag_file_4: 'el archivo ',
        update_levels: 'Actualizar niveles, grados y grupos',
        valid_file: 'Archivo válido',

        confirm_modal: {
          title: 'Confirmación',
          description:
            'Esta opción eliminará a los alumnos que ya están registrados en el colegio.',
          btn: 'Entendido',
        },
      },

      step_2: {
        table: {
          first_name: 'Nombre',
          last_name: 'Apellidos',
          gender: 'Género',
          level: 'Nivel',
          grade: 'Grado',
          group: 'Grupo',
          student_id: 'Matrícula',
          new_student_id: 'Matrícula nueva',
          parents: 'Tutores',
          error: 'Error',
          records_per_page: 'Registros por página',
        },
      },

      step_3: {
        table: {
          search: 'Buscar',
          status_top: 'Estatus',
          first_name: 'Nombre',
          last_name: 'Apellidos',
          gender: 'Género',
          level: 'Nivel',
          grade: 'Grado',
          group: 'Grupo',
          student_id: 'Matrícula',
          parents: 'Tutores',
          records_per_page: 'Registros por página',
          status: 'Estatus',

          edit_modal: {
            edit_data: 'Editar datos',
            first_name: 'Nombre (s)',
            last_name: 'Apellidos',
            level: 'Nivel',
            grade_and_group: 'Grado y grupo',
            student_id: 'Matrícula',
            new_student_id: 'Matrícula nueva',
            male: 'Masculino',
            female: 'Femenino',
            cancel: 'CANCELAR',
            save: 'GUARDAR',
          },

          parent_detail: {
            first_name: 'Nombre',
            last_name: 'Apellidos',
            email: 'Correo',
            edit: 'Editar',

            edit_parent_modal: {
              edit_tutor: 'Editar tutor',
              first_name: 'Nombre(s)',
              last_name: 'Apellidos',
              email: 'Email',
              cancel: 'Cancelar',
              save: 'Guardar',
            },
          },
        },

        modal_email_confirm: {
          title: 'Confirmación',
          description: '¿Desea enviar correo a los tutores nuevos? ',
        },

        modal: {
          title: 'Importante',
          description:
            'A continuación se muestra el listado de los alumnos y los estatus de cada uno de ellos, verifica la información antes de realizar la carga.',
        },

        modal_upload_info: {
          import_students_and_tutors: 'Importar alumnos y tutores',
          following_data_will_be_imported: 'Se cargarán los datos siguientes:',
          important: 'Importante:',
          important_description:
            'Recuerda que los datos serán remplazados con la información nueva y no podrán recuperarse una vez que la carga este completa.',
          cancel: 'Cancelar',
          upload: 'Cargar',
        },
      },

      step_4: {
        import_completed: 'Importación finalizada',
        import_success:
          'La importación se completo correctamente, puedes verificar los registros en sus secciones correspondientes',
      },

      cancel: 'CANCELAR',
      finish: 'Terminar',
      download: 'Descargar',
      validate: 'Validar',
      upload: 'Cargar',
    },
  },
  parents: {
    tutors: 'Tutores',
    search: 'Buscar',
    delete: 'Eliminar',
    delete_tutor: 'Eliminar tutor',
    send_code: 'Enviar código',
    clear_filter: 'Limpiar filtros',
    options: 'Opciones',
    create_tutor: 'Crear tutor',

    download_tutors: 'Descargar tutores',
    download_tutors_and_students: 'Descargar tutores y alumnos',
    suspend_qr: 'Suspender QR',
    registered: 'Registrados',
    not_registered: 'No registrados',
    edit_tutor: 'Editar tutor',
    records_per_page: 'Registros por página',

    photo: 'Foto',
    first_name: 'Nombre',
    last_name: 'Apellidos',
    email: 'Correo',
    tutored: 'Tutorados',
    level: 'Nivel',
    group: 'Grupo',
    automobiles: 'Automóviles',
    drivers: 'Choferes',
    status: 'Estatus',
    last_login: 'Último inicio de sesión',
    qr_status: 'Estatus QR',
    qr_code: 'QR',
    clear_filter: 'Limpiar filtros',

    edit_tutor_modal: {
      first_name: 'Nombre (s)',
      last_name: 'Apellidos',
      email: 'Correo electrónico',
      update: 'ACTUALIZAR',
      add_photo: 'Agregar foto',
      cancel: 'Cancelar',
      save: 'Guardar',
    },

    table_tutors: {
      photo: 'Foto',
      first_name: 'Nombre',
      last_name: 'Apellidos',
      level: 'Nivel',
      group: 'Grupo',
      create_student: 'Crear alumno',
      options: 'Más opciones',
      students_to_be_linked: 'Selecciona los estudiantes a ligar',
      add_student_to_tutor: 'Agregar alumno a tutor',
      edit_student: 'Editar alumno',
      search_student: 'Escribe el nombre del estudiante',
      help_search_student:
        'Escribe el nombre del estudiante a ligar con el papá',
      select_the_students: 'Selecciona los estudiantes a ligar',
      cancel: 'Cancelar',
      save: 'Guardar',
    },

    drivers_table: {
      photo: 'Foto',
      first_name: 'Nombre',
      last_name: 'Apellidos',
      email: 'Correo',
      status: 'Estatus',
      last_login: 'Último inicio de sesión',
    },

    modal_qr: {
      qr_download: 'Descarga de QR',
      download_format: 'Elije el formato de descarga',
      qr_code_size: 'Tamaño de QR',
      qr_code_size_2: 'por página en tamaño carta.',
      small: 'Pequeño',
      large: 'Grande',
      page_breaks_groups: "Descargar QR's sin salto de página entre grupos",
      cancel: 'Cancelar',
      save: 'Guardar',
    },
  },
  employee: {
    search: 'Buscar',
    employees: 'Colaboradores',
    photo: 'Foto',
    first_name: 'Nombres',
    last_name: 'Apellidos',
    email: 'Correo',
    qr_status: 'Estatus QR',
    qr_code: 'QR',
    role: 'Rol',
    delete: 'Eliminar',
    edit_collaborator: 'Editar colaborador',
    options: 'Opciones',
    create_collaborator: 'Crear colaborador',
    import_collaborators: 'Importar colaboradores',
    download_collaborators: 'Descargar colaboradores',
    download_qr_s: 'Descarga QRs',

    edit_employee_modal: {
      create_collaborator: 'Crear colaborador',
      edit_collaborator: 'Editar colaborador',
      first_name: 'Nombre (s)',
      last_name: 'Apellidos',
      email: 'Correo electrónico',
      role: 'Rol',
      add_photo: 'Añadir foto',
      update: 'Actualizar',
      cancel: 'Cancelar',
      save: 'Guardar',
    },
    modal_qr: {
      qr_download: 'Descarga de QR',
    },
  },
  configuration: {
    configuration: 'Configuración',

    location_settings_title: 'AJUSTES DE UBICACIÓN',
    payment_adjustments_title: 'AJUSTES DE PAGOS',
    cell_phone_app_settings_title: 'AJUSTES DEL MÓVIL',
    main_school_settings_title: 'AJUSTES DEL COLEGIO MATRIZ',
    permits_title: 'PERMISOS',
    general_settings_title: 'AJUSTES GENERALES',

    save_changes: 'Guardar cambios',
    add_door: 'Añadir puerta',
    download_doors: 'Descargar puertas',
    cancel: 'CANCELAR',
    save: 'GUARDAR',

    meters: 'metros',
    seconds: 'segundos',

    location_settings: {
      doors: 'Puertas',
      doors: 'Doors',
      location_settings: 'AJUSTES DE UBICACIÓN',
      door_information: 'Datos de la Puerta:',
      name: 'Nombre',
      reference_street: 'Calle de refernecia',
      door_type: 'Tipo de puerta',
      radial_distance: 'Distancia radial.',
      meters: 'metros',
      select_door_color: 'Selecciona color para la puerta (Opcional)',
      edit_door: 'Editar Puerta',
      delete_door: 'Eliminar puerta',
      delete_door_description:
        'Esta a punto de eliminar una puerta, ¿Está seguro que desea realizar dicha acción?',

      school_address: 'Dirección del colegio:',
      time_zone: 'Zona Horaria:',
      change_school_location:
        'Para cambiar la ubicación del colegio digite la dirección en el buscador',
      search: 'Buscar',

      help: {
        title: 'Añadir color a la puerta',
        description:
          'Al añadir un color a la puerta, se verá reflejado en las tarjetas de los alumnos en salidas web y en la app de Staff. Si a la puerta no se le añade color o se le quita, el color no se presenta en las tarjetas en salidas web, en Staff tomará el color de los estatus.',
      },
    },

    general_settings: {
      information: 'Información ',
      update_logo: 'ACTUALIZAR LOGO',
      college_qr: 'QR DEL COLEGIO',
      name: 'Nombre',
      payment_adjustments_title: 'AJUSTES DE PAGOS',
      profile_editing_by_tutors: 'Edición de perfil por tutores',
      profile_editing_by_tutors_help:
        'Permite a los tutores editar su información de perfil',
      student_editing_by_tutors: 'Edición de estudiantes por tutores',
      student_editing_by_tutors_help:
        'Permite a los tutores editar la foto de perfil de sus hijos',
      institution_qr_code: 'QR del Colegio',
      edit_image: 'Editar imagen',
      add_image: 'Añadir imagen',

      requests: {
        requests_title: 'Peticiones',
        range_of_time_to_apply_for_students:
          'Rango de tiempo para solicitar los alumnos',
        specify: 'Especificar',
        all_day: 'Todo el día',

        requests_help_1:
          'Controla el tiempo en el que los tutores pueden pedir a sus hijos:',
        requests_help_2:
          ': Los tutores pueden pedir a sus hijos a cualquier hora',
        requests_help_3:
          ': Los tutores solo pueden pedir a sus hijos en un rango determinado',

        minutes_before_dismissal_time:
          'minutos antes de la hora de la hora de salida',
        minutes_after_dismissal_time:
          'minutos después de la hora de la hora de salida',

        time_in_minutes_to_request_students_help_1_1:
          'Tiempo en minutos para solicitar alumnos',
        time_in_minutes_to_request_students_help_1_2:
          'Tiempo máximo en minutos para solicitar alumnos',
        time_in_minutes_to_request_students_help_2_1: 'ANTES',
        time_in_minutes_to_request_students_help_2_2: 'DESPUÉS',
        time_in_minutes_to_request_students_help_3: 'de la hora de salida.',
        time_in_minutes_to_request_students_help_4: 'Ejemplo 120 mins = 2hrs',

        time_to_request_again: 'Tiempo para volver a pedir',
        time_to_request_again_help:
          'Establece un tiempo determinado, para volver a pedir al alumno.',
      },

      mail_servers: {
        mail_servers_title: 'Servidores de correo:',
        skolable_mail: 'Correo Skolable',
        skolable_mail_help:
          'Configura la cuenta de correos con los que se enviarán los correos de bienvenida a los tutores y colaboradores una vez que se den de alta.',

        add_new_email: 'Agregar un nuevo correo',
        user: 'Usuario',
        email: 'Correo',
        pasword: 'Contraseña',
        port: 'Puerto',
        host: 'Host',
        protocol: 'Protocolo',
        cancel: 'Cancelar',
        accept: 'Aceptar',
      },

      restart_transactions: {
        restart_transactions_title: 'Reiniciar transacciones',
        restart_transactions_description_1:
          'Reinicia las transacciones que se realizaron o se encuentran en proceso del día en curso.',
        restart_transactions_description_2:
          'Este proceso es destructivo por lo que no podrá recuperar la información eliminada',
        restart: 'REINICIAR',
      },

      students_requests_settings: {
        activate_gps_assistance_for_requests:
          'Activar asistencia GPS para solicitudes',
        activate_gps_assistance_for_requests_help:
          'La asistencia de GPS permite que las solicitudes se realicen dependiendo de la ubicación del tutor.',
        activate_gps_assistance_for_requests_alert:
          'Al desactivar el uso de la geolocalización, se aceptarán todas las peticiones de alumnos del día de hoy que se encuentren con estatus de "Espera", ¿Deseas continuar?',
        advanced_options: 'Opciones avanzadas',
        scan_on_arrive: 'Solicitar al llegar',
        scan_on_arrive_help:
          'Esta opción determina que los tutores deben de escanear un código QR del colegio para poder solicitar a los alumnos.',

        advanced_options_help:
          'Configuraciones avanzadas de GPS, solo para usuarios especializados',
        maximum_waiting_time: 'Tiempo máximo de espera',
        maximum_waiting_time_help:
          'Tiempo máximo de espera para obtener una respuesta de la cuadratura por satélite.',
        accuracy_range: 'Rango de exactitud',
        accuracy_range_help:
          'Establece un rango mínimo aceptado para la respuesta de la localización',
        attempts: 'intentos',
        number_of_attempts: 'Número de intentos',
        number_of_attempts_help:
          'Establece un mínimo aceptado de intentos para una respuesta satisfactoria de la localización',
      },

      school_days: {
        school_days_title: 'Días hábiles',
        days: 'Días',
        school_days_help:
          'Selecciona los días hábiles en los que tu institución permitirá la solicitud de los alumnos.',
      },

      delivery_verification: {
        delivery_verification_title: 'Verificación de entrega',
        minutes: 'minutos',
        notification_intervals_1: 'Intervalos de las notificaciones: Cada',
        notification_intervals_help:
          'Controla el intervalo de tiempo en el que la notificación de verificación se muestra al tutor.',

        confirmation_waiting_time:
          'Tiempo de espera de confirmación: N minutos',
        confirmation_waiting_time_help:
          'Configura el lapso de tiempo que tiene el tutor para confirmar que su alumno se encuentra con él, antes de entregarlo automáticamente',
      },

      hierarchy_validation: {
        hierarchy_validation_title: 'Validación de jerarquía',
        enable_similar_hierarchy_validation:
          'Activar validación de jerarquía similar',
        hierarchy_validation_help:
          'El usuario puede actualizar y/o eliminar otros usuarios que posean un rol con una jerarquía igual o menor a la de él',
      },

      authorization_of_announcements: {
        announcement_authorization_title: 'Autorización de comunicados',
        moderator: 'Moderador de comunicados',
        announcement_authorization_help:
          'Añade un nivel de seguridad al requerir la autorización del instituto para publicar comunicados.',
      },

      carpool_settings: {
        carpool_settings_title: 'Ajustes de rondas',
        activate_carpool_authorization: 'Activar autorización de rondas',
        activate_carpool_authorization_help:
          'Añade un nivel de seguridad al requerir la autorización del instituto para la creación de rondas.',

        minimum_of_students_per_round: 'Mínimo de alumnos por ronda',
        students: 'alumnos',
        students_help:
          'Establece un mínimo de alumnos necesario para crear un ronda',
      },
    },

    main_school_settings: {
      main_school_information: 'Datos de la matriz:',

      name: 'Nombre',
      address: 'Dirección',
      phone_number: 'Teléfono',
      description: 'Descripción ',
      search: 'Buscar',
      school_address_1: 'Dirección del colegio:',
      school_address_2:
        'Para cambiar la ubicación del colegio digite la dirección en el buscador',
    },

    cell_phone_app_settings: {
      mobile_device_app_preview: 'Vista previa del dispositivo móvil',
      mobile_device_app_side_menu: 'Menú lateral del dispositivo móvil',

      left_panel: {
        school_bulletin_board: 'Avisos',
        events: 'Eventos',
        performance: 'Desempeño',
        saved: 'Guardados',
        surveys: 'Encuestas',
        payments: 'Pagos',
        qr: 'QR',
        set_up_notifications: 'Configurar notificaciones',
        activate_guided_tour: 'Activar visita guiada',
        settings: 'Configuración',
        logout: 'Cerrar sesión',
      },

      panel: {
        family: 'Familia',
        notifications: 'Notificaciones',

        mobile_app_main_screen: 'Pantalla principal del dispositivo móvil',

        sections: 'Secciones',

        pick_up: 'Entregas',
        community: 'Comunidad',
        third_parties: 'Permiso de Terceros',
        notifications: 'Notificaciones',
        carpool_deliveries: 'Entregas ronda',
        students: 'Alumnos',
        carpool: 'Rondas',
        vehicle: 'Carros',
        profile: 'Perfil',
        driver: 'Chofer',
        qr_code_profile: 'Perfil QR',
        notification_settings: 'Configuración de notificaciones',
        payments: 'Pagos',
        billing: 'Facturación',
        surveys: 'Encuestas',
        permits: 'permisos',
        authorizations: 'Pases de salida',

        pick_up_help_title: 'Entregas',
        community_help_title: 'Comunidad',
        third_parties_help_title: 'Terceros',
        notifications_help_title: 'Notificaciones',
        carpool_deliveries_help_title: 'Entregas ronda',
        students_help_title: 'Alumnos',
        carpool_help_title: 'Rondas',
        vehicle_help_title: 'Carros',
        profile_help_title: 'Perfil',
        driver_help_title: 'Chofer',
        qr_code_profile_help_title: 'Perfil QR',
        notification_settings_help_title: 'Configuración de las notificaciones',
        payments_help_title: 'Configuración para pagos',
        billing_help_title: 'Configuración de facturación',
        surveys_help_title: 'Configuración de encuestas',

        pick_up_help:
          'Permite a los tutores realizar tanto las peticiones de sus alumnos como de sus rondas.',
        community_help:
          'Permite a los tutores visualizar los avisos, eventos o cualquier comunicado emitido en la institución o al grupo en específico del alumno del tutor.',
        third_parties_help:
          'Permite a los tutores crear permisos especiales a terceras personas para que puedan recoger a sus alumnos a la institución.',
        notifications_help:
          'Permite a los tutores visualizar las notificaciones emitidas por el dispositivo',
        carpool_deliveries_help:
          'Permite a los tutores realizar las peticiones de sus rondas.',
        students_help:
          'Permite a los tutores visualizar la información de sus alumnos, así como editar la fotografía de los mismos, siempre y cuando el instituto lo permita.',
        carpool_help: 'Permite a los tutores gestionar y crear sus rondas.',
        vehicle_help:
          'Permite a los tutores gestionar la información de sus vehículos con los que recogen a sus alumnos.',
        profile_help:
          'Permite a los tutores visualizar y gestionar su información personal, siempre y cuando el instituto lo permita',
        driver_help:
          'Permite a los tutores gestionar los choferes con los que cuentan para recoger a sus alumnos de la institución.',
        qr_code_profile_help:
          'Permite a los tutores visualizar el código QR personal generado por el instituto.',
        notification_settings_help:
          'Permite a los tutores configurar las notificaciones que desean recibir en su dispositivo.',
        payments_help:
          'Permite a los tutores hacer pagos usando su dispositivo.',
        billing_help: 'Configuración de facturación',
        surveys_help:
          'Permite el acceso a la sección de encuestas publicadas por el colegio.',
      },
    },
  },
  reports: {
    reports_title: 'Reportes',
    capacity_report_title: 'Reporte de aforo',
    capacity_report_details:
      'Aforo registrado de alumnos, colaboradores, tutores y visitantes.',
    check_in_and_check_out_report_title: 'Reporte de entradas y salidas',
    check_in_and_check_out_report_details:
      'Registros históricos de entradas y salidas de alumnos, colaboradores, tutores y visitantes',
    delivery_report_title: 'Reporte de entregas',
    event_registration_title: 'Reporte de eventos',
    event_registration_details: 'Reportes de los eventos que se han creado',

    shared: {
      download_pdf: 'Descargar PDF',
      download_xlsx: 'Descargar XLSX',
      search: 'Buscar',
      more_options: 'Más Opciones',
      clear_filters: 'Limpiar filtros',
    },

    capacity_report: {
      profile: 'Perfil',
      all: 'Todos',
      level: 'Nivel',
      group: 'Grupo',
      role: 'Rol',
      temperature: 'Temperatura',
      initial: 'Inicial',
      final: 'Final',

      total_capacity: 'Total Aforo',
      total_students: 'Total de Alumnos',
      total_number_of_collaborators: 'Total de Colaboradores',
      total_number_of_tutors: 'Total de tutores',
      total_visitors: 'Total de Visitantes',

      students: 'Alumnos',
      collaborators: 'Colaboradores',
      tutors: 'Tutores',
      visitors: 'Visitantes',

      entry_date: 'Fecha Entrada',
      entry_time: 'Hora Entrada',
      first_name: 'Nombre',
      last_name: 'Apellido',
      enrollment: 'Matrícula ',
      gender: 'Género',
      grade: 'Grado',
      visited: 'Visitó a',
    },

    check_in_and_check_out_report: {
      graphics: 'Gráficas',
      profile: 'Perfil',

      all: 'Todos',

      level: 'Nivel',
      group: 'Grupo',
      role: 'Rol',
      temperature: 'Temperatura',
      initial: 'Inicial',
      final: 'Final',
      start_date: 'Fecha de inicio',
      end_date: 'Fecha de término',

      total_students: 'Total de Alumnos',
      total_number_of_collaborators: 'Total de Colaboradores',
      total_number_of_tutors: 'Total de tutores',
      total_visitors: 'Total de Visitantes',

      first_name: 'Nombre',
      last_name: 'Apellido',
      entry_date: 'Fecha Entrada',
      entry_time: 'Hora Entrada',
      out_date: 'Fecha Salida',
      out_time: 'Hora Salida',
      enrollment: 'Matrícula ',
      grade: 'Grado',
      photo: 'Foto',
      gender: 'Género',
      visited: 'Visitó a',

      students: 'Alumnos',
      collaborators: 'Colaboradores',
      tutors: 'Tutores',
      visitors: 'Visitantes',
    },

    delivery_report: {
      graphics: 'Gráficas',
      level: 'Nivel',
      group: 'Grupo',
      all: 'Todos',
      start_date: 'Fecha de inicio',
      end_date: 'Fecha de término',

      first_name: 'Nombre',
      last_name: 'Apellido',
      enrollment: 'Matrícula',
      requested: 'Solicitado',
      called: 'En Camino',
      delivered: 'Entregado',
      cancelled: 'Cancelado',
      more_info: 'Mas información',

      tutor_confirmation: 'Confirmación del tutor',
      delivered_from_staff: 'Entregado desde staff',
      check_out: 'Registro de salida',
    },

    event_reports: {
      event_reports_title: 'Reportes de eventos',
      search: 'Escribe el nombre del evento para buscar',
      event_title: 'Título del evento',
      generate_event_reports: 'Genera reportes de tus eventos',
      start: 'Inicio:',
      end: 'Término:',
    },
  },
  levels: {
    levels_title: 'Niveles',
    save_changes: 'Guardar cambios',
    add_level: 'Agregar nivel',
    download_levels: 'Descargar niveles',
    general_information: 'DATOS GENERALES',
    doors: 'Puertas',
    level_information: 'Información del nivel',
    name: 'Nombre',
    abbreviation: 'Abreviación',
    dismissal: 'Hora salida',
    extracurricular_level: 'Nivel extracurricular',
  },
  extracurricular: {
    extracurricular_title: 'Extracurriculares',

    photo: 'Foto',
    first_name: 'Nombre',
    last_name: 'Apellidos',
    level: 'Nivel',
    group: 'Grupo',
    student_id: 'Matrícula',

    add_students_modal: {
      add_students_title: 'Añadir alumnos',
      search_student: 'Nombre del alumno',
      search_help: 'Escribe el nombre del alumno a ligar con el nivel',
      level: 'Nivel',
      groups: 'Grupos',
      students: 'Alumnos',
    },

    import_students_modal: {
      import_students_modal_title:
        'Importar alumnos y niveles extracurriculares',

      upload_file: 'Sube tu archivo',
      completed: 'Terminado',
      error_corrections: 'Corrección de errores ',
      drag_your_excel_file_here: 'Arrastra tu archivo Excel aquí   ',
      or: 'O',
      select: 'selecciona',
      the_file: 'el archivo',
      import_your_students_excel_file_example:
        'Importa tu archivo Excel de tus alumnos como se muestra en el ejemplo.',
      validate: 'Validar',

      student_id: 'Matrícula',
      grade_level: 'Nivel',
      activity: 'Actividad',
      group: 'Grupo',
      error: 'Error',

      last_step_warn:
        'Algunos archivos no se pudieron importar, descarga el archivo para verificar los registros',
      warning: 'Advertencia',
    },
  },
  devices: {
    devices_title: 'Dispositivos',
    add_device: 'Añadir dispositivo',
    ipad: 'Ipad',
    android_tablet: 'Tableta Android',
    permissions: 'Permisos',

    access_control: 'Control de ingresos',
    exit_control: 'Control de salidas',

    fixed_assistant: 'Dispositivo iPad, asistente fijo',
    synchronized_device: 'Dispositivo sincronizado',
    permissions: 'Permisos',
    incoming_control: 'Control de ingresos',
    unpair: 'Desvincular',
    linked_device: 'Dispositivo vinculado',
    klipy_devices: 'Dispositivos Klipy',

    name_ipad: 'Ipad de',
  },
  surveys: {
    surveys_title: 'Encuestas',
    custom_survey: 'Encuesta personalizada',
    name: 'Nombre',
    frequency: 'Periodicidad',
    publication_date: 'Fecha de publicación ',
    status: 'Estatus',
    alert_responses: 'Respuestas de alerta',

    completed: 'Terminada',
    published: 'Publicado',

    delete_survey_title: 'Eliminar encuesta',
    delete_survey_description:
      '¿Está seguro que desea realizar dicha acción, este proceso es irreversible y no podrá recuperar la información?',

    make_survey_copy: 'Duplicar encuesta',
    view_survey: 'Ver encuesta',
    survey_details: 'Detalle de la encuesta',
    edit_survey: 'Editar encuesta',
    stop_survey: 'Detener encuesta',

    creator: 'Creador',
    frequency: 'Periodicidad',
    start_date: 'Fecha de inicio',
    end_date: 'Fecha de término ',

    last_name: 'Apellidos',
    level: 'Nivel',
    grade: 'Grado ',
    group: 'Grupo',
    answers: 'Respuestas',
    with_alert: 'Con alerta',
    registration: 'Matrícula',
    date_and_time: 'Fecha y hora',

    question: 'Pregunta',
    answers: 'Respuestas',
    alert: 'Alerta',
    answered_by: 'Contestado por',

    survey: 'Encuesta',
    questions: 'Preguntas',
    catalog: 'Catalogar',
    audience: 'Audiencia',
    preview: 'Previo',

    create_survey_title: 'Crear encuesta',
    edit_survey_title: 'Editar encuesta',
    create_survey: {
      survey_name: 'Nombre de la encuesta',
      select_periodicity: 'Selecciona periodicidad',
      only_once: 'SOLO UNA VEZ',
      daily: 'DIARIO',
      weekly: 'SEMANAL',
      monthly: 'MENSUAL',
      start_date: 'Fecha inicial',
      end_date: 'Fecha de término',

      write_your_question: 'Escribe tu pregunta',
      select_the_type: 'Selecciona el tipo',
      option: 'Opción',
      simple: 'SIMPLE ',
      multiple: 'MÚLTIPLE',
      open: 'ABIERTA',
      add_question: 'Añadir pregunta',

      check_alert:
        'Activa la casilla de las respuestas que consideras como respuestas de alerta.',

      institutional: 'Institucional',
      the_entire_institution_will_be_notified:
        'Toda la institución será notificada',
      levels: 'Niveles',
      added_levels: 'Niveles Agregados',
      drag_levels: 'Arrastrar Niveles',
      groups: 'Grupos',
      added_groups: 'Grupos Agregados',
      drag_groups: 'Arrastrar Grupos',
      subgroups: 'Subgrupos',
      added_subgroups: 'Subgrupos agregados',
      drag_subgroups: 'Arrastrar subgrupos',
      collaborators: 'Colaboradores',
      added_collaborators: 'Colabordores Agregados',
      drag_collaborators: 'Arrastrar colaboradores',
      students_a: 'Estudiantes',
      students_b: 'Alumnos',
      added_students: 'Alumnos Agregados',
      drag_students: 'Arrastrar alumnos',

      survey_name: 'Nombre de la encuesta',
      periodicity: 'Periodicidad',
      start_date: 'Fecha de inicio ',
      end_date: 'Fecha de término',
      vew_audience_list: 'Ver audiencia',
      audience: 'Audiencia',
      schedule_survey: 'Programar encuesta',
      required_for_access: 'Requerida para acceso',
      notify_by_mail: 'Notificar por correo',
      view_questions: 'Ver Preguntas',

      check_covid:
        'Activa la casilla de las respuestas que consideras como respuestas de alerta.',
      covid_question: 'Su hijo(a) presenta los siguientes síntomas?',
      multiple: 'MULTIPLE',
      dry_cough: 'Tos seca',
      headache: 'Dolor de cabeza',
      difficulty_breathing: 'Dificultad para respirar',
      general_discomfort: 'Malestar general',
      sore_throat: 'Dolor de garganta',
      temperature: 'Temperatura',
      no_symptoms: 'No presenta síntomas',
    },
  },
  rounds: {
    rounds_title: 'Rondas',
    photo: 'Foto',
    name: 'Nombre',
    creation_date: 'Fecha de creación',
    type: 'Tipo',
    status: 'Estado',
    tutor: 'Tutor',
    students: 'Alumnos',
    options: 'Opciones',

    last_name: 'Apellidos',

    authorization_pending: 'Autorización pendiente',
    authorized: 'Autorizado',
    authorize: 'Autorizar',
    deny: 'Denegar',
  },
  appointments: {
    appointments_title: 'Citas',
    subject: 'Asunto',
    start_date_time: 'Fecha y hora inicio',
    end_date_time: 'Fecha y hora fin',
    host: 'Host',
    guests: 'Invitados',
    status: 'Estatus',

    start_date: 'Fecha de inicio',
    end_date: 'Fecha de término',
    contributor: 'Colaborador',

    date: 'Fecha',
    time: 'Hora',

    edit_quote: 'Editar cita',
    subject: 'Asunto',
    who_are_you_visiting: '¿A quién visita?',
    date: 'Fecha',

    confirm_send_notifications: 'Confirmar',
    send_notifications: 'Se enviarán notificaciones a los invitados.',
    send_notifications_confirm: '¿Deseas continuar?',

    delete_appointment_title: 'Eliminar cita',
    delete_appointment_description:
      '¿Está seguro que desea realizar dicha acción, este proceso es irreversible y no podrá recuperar la información?',

    delete: 'Eliminar',
    send_invitations: 'Enviar invitaciones',
    send_invitation: 'Enviar invitacion',
    edit: 'Editar',

    appointment_details: 'Detalle de la cita',

    first_name: 'Nombre',
    last_name: 'Apellidos ',
    e_mail: 'Correo',
    type: 'Tipo',
    add_guest: 'Agregar invitado',
    email: 'Correo electrónico',

    send_notification: 'Enviar invitación',
    remove_guest_title: 'Eliminar invitado',
    remove_guest_details:
      '¿Está seguro que desea realizar dicha acción, este proceso es irreversible y no podrá recuperar la información?',

    guest_options: 'Opciones de invitados',
    add_tutors: 'Añadir tutores',
    add_tutor: 'Añadir tutor',
    add_external_guest: 'Añadir invitado externo',
  },
}
